/**
 * ftp服务器配置api接口
 * @author： xuyd
 * @date：2022-01-12
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'

const serviceModule = context.sunflower

export default {

  /**
   * 列表检索
   * @param params
   */
  selectSshList: (params) => {
    return request.post(serviceModule + "/remote/ssh/searchList", params);
  },

  /**
   * 保存
   * @param params
   */
  saveSsh: (params) => {
    return request.post(serviceModule + "/remote/ssh/save", params);
  },

  /**
   * 删除
   * @param id
   */
  deleteSsh: (id) => {
    return request.post(serviceModule + "/remote/ssh/delete?id=" + id);
  },

  /**
   * 查询列表
   */
  querySshList: () => {
    return request.get(serviceModule + "/remote/ssh/querySshList");
  },

  /**
   * 连通性测试
   * @param params
   */
  validateConn: (params) => {
    return request.post(serviceModule + "/remote/ssh/validateConn", params);
  },

}
